import { useRef, useState, useEffect } from "react";
import { Eraser, PenLine } from "lucide-react";

export default function SignaturePad({ onChange, testid = "signature-pad" }) {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [hasInk, setHasInk] = useState(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    const w = c.offsetWidth;
    c.width = w * ratio;
    c.height = 160 * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#003087";
  }, []);

  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const start = (e) => {
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    e.preventDefault();
  };

  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    if (!hasInk) setHasInk(true);
    e.preventDefault();
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(ref.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = ref.current;
    const ctx = c.getContext("2d");
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.restore();
    setHasInk(false);
    onChange(null);
  };

  return (
    <div>
      <div className="relative rounded-2xl border-2 border-dashed border-[#00AEEF]/50 bg-white overflow-hidden">
        <canvas
          ref={ref}
          data-testid={testid}
          className="w-full h-40 block cursor-crosshair"
          style={{ touchAction: "none" }}
          onPointerDown={start}
          onPointerMove={move}
          onPointerUp={end}
          onPointerLeave={end}
        />
        {!hasInk && (
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none text-[#94A3B8]">
            <PenLine size={22} className="mb-1.5" />
            <span className="text-xs font-semibold">Firma qui con il dito o col mouse</span>
          </div>
        )}
      </div>
      {hasInk && (
        <button type="button" data-testid={`${testid}-clear`} onClick={clear}
          className="mt-2 text-xs font-semibold text-[#64748B] hover:text-[#003087] inline-flex items-center gap-1.5 transition-colors duration-200">
          <Eraser size={13} /> Cancella e rifirma
        </button>
      )}
    </div>
  );
}
